module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-empty-b8a22c47586d702503234047f60be78c.svg";